import React from "react";
import PropTypes from "prop-types";
import OverflowTooltip from "../OverflowToolTip";
import styles from "./item_label.module.css";

const ItemLabel = ({ label }) => (
  <OverflowTooltip title={label}>
    <div className={styles.label}>{label}</div>
  </OverflowTooltip>
);

ItemLabel.propTypes = {
  label: PropTypes.string
};

ItemLabel.defaultProps = {
  label: ""
};

export default ItemLabel;
